import { splitSearchTerms } from './search-navigation.js';

/**
 * 検索語に一致した部分へ強調用の span を差し込む。
 *
 * 対象は formatMarkdownInline() が組み立てたあとの HTML なので、
 * 文字列置換ではなくテキストノードだけをたどって書き換える。
 * タグ名や属性値の中に検索語が含まれていても壊さないため。
 */
export function highlightHtmlText(htmlContent: string, query: string): string {
  // 空白で区切った語句をそれぞれ強調する。長い語句を先に並べ、重なる語句は長い方を優先する。
  const terms = Array.from(new Set(splitSearchTerms(query))).sort((a, b) => b.length - a.length);
  if (terms.length === 0) {
    return htmlContent;
  }

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlContent;

  const regexQuery = terms.map((term) => term.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')).join('|');
  const regex = new RegExp(`(${regexQuery})`, 'gi');

  const walkNodes = (parent: Node) => {
    for (const child of Array.from<ChildNode>(parent.childNodes)) {
      if (child.nodeType === Node.TEXT_NODE) {
        const text = child.nodeValue || '';
        if (terms.some((term) => text.toLowerCase().includes(term))) {
          // テキストを innerHTML へ渡すと、エスケープ済み本文の「<」などが
          // タグとして再解釈されてしまう。テキストノードと span 要素で組み立てる。
          const fragment = document.createDocumentFragment();
          let lastIndex = 0;
          regex.lastIndex = 0;
          let match: RegExpExecArray | null;
          while ((match = regex.exec(text)) !== null) {
            if (match.index > lastIndex) {
              fragment.append(document.createTextNode(text.slice(lastIndex, match.index)));
            }
            const span = document.createElement('span');
            span.className = 'search-highlight';
            span.textContent = match[1];
            fragment.append(span);
            lastIndex = match.index + match[1].length;
          }
          if (lastIndex < text.length) {
            fragment.append(document.createTextNode(text.slice(lastIndex)));
          }
          child.replaceWith(fragment);
        }
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        walkNodes(child);
      }
    }
  };

  walkNodes(tempDiv);
  return tempDiv.innerHTML;
}
